import mitt from 'mitt'

export const MODAL_SHOW = 'bv::show::modal'
export const MODAL_HIDE = 'bv::hide::modal'

export const modalBus = mitt()

export function showModal(modalId) {
	if (modalId != null) {
		modalBus.emit(MODAL_SHOW, modalId)
	}
}

export function hideModal(modalId) {
	if (modalId != null) {
		modalBus.emit(MODAL_HIDE, modalId)
	}
}

export function onModalShow(handler) {
	modalBus.on(MODAL_SHOW, handler)
	return () => modalBus.off(MODAL_SHOW, handler)
}

export function onModalHide(handler) {
	modalBus.on(MODAL_HIDE, handler)
	return () => modalBus.off(MODAL_HIDE, handler)
}
